import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";

export const StudentcategoryFields: IField[] = [
  { name: "name", type: "text", label: "Name", size: {lg: 6}, position: 1 },
  { name: "remarks", type: "text", label: "Remarks", size: {lg: 6}, position: 2 }
].sort((a: IField, b: IField) => a.position - b.position);